import React from 'react'
import { Tabs } from 'element-react'

const MenuSG = () => {
    return (
        <div>
            <Tabs
                activeName="2"
                onTabClick={tab => console.log(tab.props.name)}
            >
                <Tabs.Pane label="User" name="1">
                    User
                </Tabs.Pane>
                <Tabs.Pane label="Config" name="2">
                    Config
                </Tabs.Pane>
                <Tabs.Pane label="Role" name="3">
                    Role
                </Tabs.Pane>
                <Tabs.Pane label="Task" name="4">
                    Task
                </Tabs.Pane>
            </Tabs>
        </div>
    )
}

export default MenuSG
